import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { CalendarScheduleIcon } from '@moia-dev/pace-icons'
import { FleetPlannerAreaRoutes } from './FleetPlannerAreaRoutes'

export const FleetPlannerAreaNavigationIcon = CalendarScheduleIcon

export const FleetPlannerAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={FleetPlannerAreaRoutes.route}
      Icon={CalendarScheduleIcon}
    />
  )
}
